import api from "@/services/api";

export default {
  async login(user) {
    const response = await api.post("/auth/login", {
      email: user.email,
      password: user.password,
    });

    if (!response || !response.data) {
      throw new Error('Respuesta de login inválida: estructura incorrecta');
    }

    if (response.data.token) {
      localStorage.setItem("access_token", response.data.token);
    } else {
      throw new Error('No se recibió token de autenticación');
    }

    return response.data;
  },

  async register(userData) {
    const response = await api.post("/auth/register", userData);
    return response.data;
  },

  async closeRemoteSession(token, email) {
    const response = await api.post("/auth/close-remote-session", {
      token: token,
      email: email,
    });

    return response.data;
  },

  async getDoctorRoles() {
    const response = await api.get("/auth/doctor-roles");
    return response.data;
  },

  async getSpecialties() {
    const response = await api.get("/auth/specialties");
    return response.data;
  },

  async getPlans() {
    const response = await api.get("/plans");
    return response.data;
  },

  async logout() {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      // Continuar con el logout local aunque falle el servidor
    } finally {
      localStorage.removeItem("access_token");
    }
  },
};